var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.chartComponent,{tag:"component"},[_c('template',{slot:"value"},_vm._l((_vm.translatedValues),function(value,index){return _c('value-component',{key:index,attrs:{"value":value}})}),1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }